<template>
  <div id="admin-report">
    <!-- modals -->
    <modal
      v-if="templates.length > 0 && templates[states.selectTemplate] != null"
      id="select-template-modal"
      title="Select template"
      bodyMaxHeight="70vh"
      showBodyYScroll="true"
      size="md3"
      margintop="10%"
    >
      <div class="container-fluid">
        <div class="row">
          <span>
            Reported {{ numTemplate }} templates,
            {{ fixedTemplateIds.length }} fixed
            <i class="fa fa-check-circle-o text-success" />.
          </span>
        </div>
        <div class="row mt-2">
          <div class="table table-hover">
            <thead class="thead-dark">
              <tr>
                <th class="w-25">Template name</th>
                <th class="w-25">Fixed?</th>
                <th class="w-25">
                  <i class="fa fa-check" />/<i class="fa fa-times" />/#Report
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(t, i) in templates">
                <tr
                  v-if="fixedTemplateIds.indexOf(t.id) == -1"
                  :class="{
                    clickable: true,
                    'table-active': templates[states.selectTemplate].id == t.id
                  }"
                  @click="
                    localEventHandler('click-select-template-item', {
                      selectTemplate: i
                    })
                  "
                  :key="t.id"
                >
                  <td>{{ t.id }}</td>
                  <td>
                    <i
                      class="fa fa-check-circle-o text-success"
                      v-if="fixedTemplateIds.indexOf(t.id) != -1"
                    />
                  </td>
                  <td>
                    {{ t.reports.filter(r => r.verified == true).length }}
                    /
                    {{ t.reports.filter(r => r.verified == false).length }}
                    / {{ t.reports.length }}
                  </td>
                </tr>
              </template>
              <template v-for="(t, i) in templates">
                <tr
                  v-if="fixedTemplateIds.indexOf(t.id) != -1"
                  :class="{
                    clickable: true,
                    'table-active': templates[states.selectTemplate].id == t.id
                  }"
                  @click="
                    localEventHandler('click-select-template-item', {
                      selectTemplate: i
                    })
                  "
                  :key="t.id"
                >
                  <td>{{ t.id }}</td>
                  <td>
                    <i
                      class="fa fa-check-circle-o text-success"
                      v-if="fixedTemplateIds.indexOf(t.id) != -1"
                    />
                  </td>
                  <td>
                    {{ t.reports.filter(r => r.verified == true).length }}
                    /
                    {{ t.reports.filter(r => r.verified == false).length }}
                    / {{ t.reports.length }}
                  </td>
                </tr>
              </template>
            </tbody>

            <!-- <div class="list-group w-100">
            <div
              v-for="(t, i) in templates"
              :key="t.id"
              :class="{
                'list-group-item': true,
                'list-group-item-action': true,
                clickable: true,
                active: i == states.selectTemplate
              }"
              @click="
                localEventHandler('click-select-template-item', {
                  selectTemplate: i
                })
              "
            >
              {{ t.id }}
            </div>
          </div> -->
          </div>
        </div>
      </div>
    </modal>
    <div>
      <div class="container-fluid" v-if="templates[states.selectTemplate]">
        <div v-for="t in [templates[states.selectTemplate]]" :key="t.id">
          <div class="row no-gutters">
            <div id="div-issues" class="col-xl-4 col-lg-5">
              <div class="row mr-4 mb-2">
                <div class="col-12 d-flex">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-dark m-1"
                    @click="localEventHandler('click-menu-prev-template')"
                  >
                    &lt;
                  </button>
                  <button
                    type="button"
                    class="btn btn-light w-100 line-break m-1"
                    @click="localEventHandler('click-menu-template')"
                  >
                    <b> {{ t.id }}</b>
                  </button>
                  <button
                    type="button"
                    :class="{
                      btn: true,
                      'btn-sm': true,
                      'btn-outline-dark': fixedTemplateIds.indexOf(t.id) == -1,
                      'btn-outline-success':
                        fixedTemplateIds.indexOf(t.id) != -1,
                      'm-1': true
                    }"
                    @click="
                      localEventHandler('click-fixed-template', { template: t })
                    "
                  >
                    <i
                      class="fa fa-circle-o"
                      v-if="fixedTemplateIds.indexOf(t.id) == -1"
                      aria-hidden="true"
                    />
                    <i class="fa fa-check-circle-o" v-else aria-hidden="true" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-dark m-1"
                    @click="localEventHandler('click-menu-next-template')"
                  >
                    &gt;
                  </button>
                </div>
              </div>
              <div class="row ml-2">
                <span class="m-1"> <b> Testers: </b> </span>
                <span class="m-1" v-for="u in t.testers" :key="u.id">
                  <small>
                    <i class="fa fa-user-o mr-1" aria-hidden="true" />
                    <b>{{ u.name }}</b> ({{ u.id }})
                  </small>
                </span>
              </div>
              <div class="row report-panel mr-4">
                <div
                  class="col-12 my-2"
                  v-for="(type, j) in (_ => {
                    var x = Array.from(new Set(t.reports.map(x => x.type)))
                    x.sort((a, b) => rcode[a].order - rcode[b].order)
                    return x
                  })()"
                  :key="type"
                >
                  <div class="row m-2">
                    <span class="mr-2">
                      <b> {{ j + 1 }}. {{ rcode[type].caption }} </b>
                    </span>
                  </div>
                  <div class="list-group w-100">
                    <template v-for="r in t.reports">
                      <div
                        class="list-group-item flex-column align-items-start"
                        v-if="r.type == type"
                        :key="r.id"
                      >
                        <div class="d-flex w-100 justify-content-between">
                          <div class="mb-3">
                            <span class="m-1">
                              <small>
                                <i
                                  class="fa fa-user-o mr-2"
                                  aria-hidden="true"
                                />
                                <b>{{ r.tester.name }}</b> ({{ r.tester.id }})
                              </small>
                            </span>
                            <span class="badge badge-info ml-1">
                              Test {{ r.testId }}#{{ r.testSeqNo + 1 }}
                            </span>
                            <span
                              :class="{
                                badge: true,
                                'badge-primary': r.checkType == 'detail',
                                'badge-secondary': r.checkType == 'simple',
                                'ml-1': true
                              }"
                            >
                              {{ r.checkType }}
                            </span>
                          </div>
                          <div>
                            <span
                              :class="{
                                clickable: true,
                                badge: true,
                                'btn-outline-dark': r.verified != true,
                                'btn-outline-success': r.verified == true,
                                'm-1': true
                              }"
                              @click="
                                localEventHandler('click-verify-question', {
                                  verified: true,
                                  report: r
                                })
                              "
                            >
                              <i class="fa fa-check" area-hidden="true" />
                              <small> </small>
                            </span>
                            <span
                              :class="{
                                clickable: true,
                                badge: true,
                                'btn-outline-dark': r.verified != false,
                                'btn-outline-danger': r.verified == false,
                                'm-1': true
                              }"
                              @click="
                                localEventHandler('click-verify-question', {
                                  verified: false,
                                  report: r
                                })
                              "
                            >
                              <i class="fa fa-times" area-hidden="true" />
                              <small> </small>
                            </span>
                            <span
                              class="m-1 clickable badge btn-outline-primary"
                              @click="
                                localEventHandler('click-report-question', {
                                  report: r
                                })
                              "
                            >
                              <i class="fa fa-search" area-hidden="true" />
                              <small> </small>
                            </span>
                          </div>
                        </div>
                        <p class="line-break">
                          <template v-if="r.message != ''">
                            {{ r.message }}
                          </template>
                          <template v-else> [No comment] </template>
                        </p>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-8 col-lg-7">
              <div
                :class="{ row: true, 'view-panel': states.windowWidth >= 992 }"
              >
                <!-- lang=en -->
                <div id="div-q1" class="col-xl-6 col-lg-12" v-if="question.key">
                  <div class="col-12">
                    <h5>Question</h5>
                  </div>
                  <div class="col-12 my-2">
                    <span class="mj" v-html="question.content" />
                  </div>
                  <div class="col-12" v-if="question.contentImageData">
                    <img
                      class="content-image"
                      v-bind:src="
                        'data:image/jpeg;base64,' + question.contentImageData
                      "
                    />
                  </div>
                  <div class="col-12">
                    <h5>Answers</h5>
                  </div>
                  <div class="col-12" v-if="question.answers">
                    <ul class="ans-lists">
                      <template v-for="(a, i) in question.answers">
                        <li class="answer-style" :key="i">
                          <span>{{ listChar(i) + '. ' }}</span>
                          <span class="mj" v-html="a" />
                        </li>
                      </template>
                    </ul>
                  </div>
                  <div class="col-12" v-if="question.answerImagesData">
                    <ul class="ans-lists">
                      <template v-for="(a, i) in question.answerImagesData">
                        <li class="answer-style" :key="i">
                          <span>{{ listChar(i) }}</span>
                          <img
                            class="answer-image"
                            v-bind:src="'data:image/jpeg;base64,' + a"
                          />
                        </li>
                      </template>
                    </ul>
                  </div>
                  <div class="col-12">
                    <h5>Solution</h5>
                  </div>
                  <div v-if="question.solution">
                    <div class="col-12">
                      <table class="table">
                        <tr>
                          <th style="width:75px">Line #</th>
                          <th></th>
                        </tr>
                        <tr v-for="(rows, i) in question.solution" :key="i">
                          <td>{{ i + 1 }}</td>
                          <td>
                            <span
                              v-if="rows.type === 'text_left'"
                              class="example-row align-center mj"
                              v-html="rows.data"
                            />
                            <span
                              v-if="rows.type === 'text_center'"
                              class="example-row align-center mj"
                              v-html="rows.data"
                            />
                            <div
                              v-if="rows.type === 'img'"
                              class="example-row example-image align-center"
                            ></div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 mb-3">
                    <small> key: {{ question.key }} </small>
                  </div>
                </div>
                <!-- lang=zh -->
                <div
                  id="div-q2"
                  class="col-xl-6 col-log-12"
                  v-if="question.key"
                >
                  <div class="col-12">
                    <h5>Question</h5>
                  </div>
                  <div class="col-12 my-2">
                    <span class="mj" v-html="refQuestion.content" />
                  </div>
                  <div class="col-12" v-if="question.contentImageData">
                    <img
                      class="content-image"
                      v-bind:src="
                        'data:image/jpeg;base64,' + question.contentImageData
                      "
                    />
                  </div>
                  <div class="col-12">
                    <h5>Answers</h5>
                  </div>
                  <div class="col-12" v-if="refQuestion.answers">
                    <ul class="ans-lists">
                      <template v-for="(a, i) in refQuestion.answers">
                        <li class="answer-style" :key="i">
                          <span>{{ listChar(i) + '. ' }}</span>
                          <span class="mj" v-html="a" />
                        </li>
                      </template>
                    </ul>
                  </div>
                  <div class="col-12" v-if="question.answerImagesData">
                    <ul class="ans-lists">
                      <template v-for="(a, i) in question.answerImagesData">
                        <li class="answer-style" :key="i">
                          <span>{{ listChar(i) }}</span>
                          <img
                            class="answer-image"
                            v-bind:src="'data:image/jpeg;base64,' + a"
                          />
                        </li>
                      </template>
                    </ul>
                  </div>
                  <div class="col-12">
                    <h5>Solution</h5>
                  </div>
                  <div v-if="refQuestion.solution">
                    <div class="col-12">
                      <table class="table">
                        <tr>
                          <th style="width:75px">Line #</th>
                          <th></th>
                        </tr>
                        <tr v-for="(rows, i) in refQuestion.solution" :key="i">
                          <td>{{ i + 1 }}</td>
                          <td>
                            <span
                              v-if="rows.type === 'text_left'"
                              class="example-row align-center mj"
                              v-html="rows.data"
                            />
                            <span
                              v-if="rows.type === 'text_center'"
                              class="example-row align-center mj"
                              v-html="rows.data"
                            />
                            <div
                              v-if="rows.type === 'img'"
                              class="example-row example-image align-center"
                            ></div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 mb-3">
                    <small> key: {{ refQuestion.key }} </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rcode from '@/app/report-code'
import api_admin from '@/api/api_admin'
import Modal from '@/components/Modal.vue'
// import MathJax from '@/MathJax'

export default {
  name: 'AdminReport',
  components: {
    modal: Modal
  },
  data () {
    return {
      rcode: rcode,
      templates: [],
      question: {},
      refQuestion: {},
      numTemplate: 0,
      fixedTemplateIds: [],
      states: {
        batchId: null,
        selectTemplate: 0,
        loading: false,
        doShowFixedTemplates: true,
        windowWidth: window.innerWidth
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onWindowsResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowsResize)
  },
  created () {
    if (!sessionStorage['show-fixed-templates']) {
      sessionStorage['show-fixed-templates'] = true
    }
    this.states.batchId = sessionStorage.batchId
    // load user settings from sessionStorage
    if (sessionStorage.doshowFixedTemplates) {
      this.doShowFixedTemplates = sessionStorage.doshowFixedTemplates == 'true'
    }
    this.states.loading = true
    this.fetchReports()
  },
  updated () {
    if ($('#div-q1')[0]) {
      renderMathInElement($('#div-q1')[0], {
        delimiters: [
          { left: '$$', right: '$$', display: true },
          { left: '$', right: '$', display: false }
        ]
      })
    }
    if ($('#div-q2')[0]) {
      renderMathInElement($('#div-q2')[0], {
        delimiters: [
          { left: '$$', right: '$$', display: true },
          { left: '$', right: '$', display: false }
        ]
      })
    }
    // MathJax.config('mj')
  },

  methods: {
    localEventHandler (name, event) {
      if (!this.states.loading) {
        if (name == 'click-report-question') {
          if (this.question && event.report.question.key != this.question.key) {
            this.fetchQuestion(
              event.report.question.key,
              event.report.question.ansref
            )
            this.fetchRefQuestion(
              event.report.refQuestion.key,
              event.report.question.ansref
            )
          } else {
            this.question = {}
            this.refQuestion = {}
          }
        } else if (name == 'click-verify-question') {
          if (event.report.verified == event.verified) {
            this.updateReportVerified(event.report.id, null)
          } else {
            this.updateReportVerified(event.report.id, event.verified)
          }
        } else if (name == 'click-menu-prev-template') {
          if (this.states.selectTemplate > 0) {
            this.states.selectTemplate -= 1
            this.question = {}
            this.refQuestion = {}
          }
        } else if (name == 'click-menu-template') {
          $('#select-template-modal').modal('show')
        } else if (name == 'click-menu-next-template') {
          if (this.states.selectTemplate < this.templates.length - 1) {
            this.states.selectTemplate += 1
            this.question = {}
            this.refQuestion = {}
          }
        } else if (name == 'click-select-template-item') {
          if (event.selectTemplate != this.states.selectTemplate) {
            this.states.selectTemplate = event.selectTemplate
            this.question = {}
            this.refQuestion = {}
            $('.modal').modal('hide')
          }
        } else if (name == 'click-fixed-template') {
          this.updateTemplateFixed(
            this.states.batchId,
            event.template.id,
            this.fixedTemplateIds.indexOf(event.template.id) == -1
          )
        } else if (name == 'click-hide-fixed-template') {
          this.states.doShowFixedTemplates = false
          sessionStorage['show-fixed-templates'] = false
          this.fetchReports()
        } else if (name == 'click-show-fixed-template') {
          this.states.doShowFixedTemplates = true
          sessionStorage['show-fixed-templates'] = true
          this.fetchReports()
        } else if (name == 'window-resize') {
          this.states.windowWidth = window.innerWidth
        }
      }
    },
    updateTemplateFixed (batchId, templateId, fixed) {
      api_admin.update_template_fixed(batchId, templateId, fixed).then(res => {
        if (res.success == true) {
          if (res.fixed == true) {
            this.fixedTemplateIds.push(res.templateId)
          } else {
            this.fixedTemplateIds = this.fixedTemplateIds.filter(
              x => x != res.templateId
            )
          }
        }
      })
    },
    updateReportVerified (reportId, verified) {
      api_admin.update_report_verified(reportId, verified).then(res => {
        if (res.success) {
          let i = this.templates[this.states.selectTemplate].reports
            .map(x => x.id)
            .indexOf(res.reportId)
          this.templates[this.states.selectTemplate].reports[i].verified =
            res.verified
        }
      })
    },
    fetchQuestion (key, ansref) {
      this.states.loading = true
      api_admin.get_question(key).then(q => {
        if (q.answers && ansref) {
          q.answers = ansref.map(x => q.answers[x - 1])
        }
        if (q.answerImages && ansref) {
          q.answerImages = ansref.map(x => q.answerImages[x - 1])
        }
        return api_admin.add_images_to_question(q).then(q => {
          this.states.loading = false
          Object.assign(this.question, q)
          this.$nextTick(_ => {
            this.$forceUpdate()
          })
        })
      })
    },
    fetchRefQuestion (key, ansref) {
      this.states.loading = true
      api_admin.get_question(key).then(q => {
        if (q.answers && ansref) {
          q.answers = ansref.map(x => q.answers[x - 1])
        }
        if (q.answerImages && ansref) {
          q.answerImages = ansref.map(x => q.answerImages[x - 1])
        }
        this.states.loading = false
        Object.assign(this.refQuestion, q)
        this.$nextTick(_ => {
          this.$forceUpdate()
        })
      })
    },

    fetchReports () {
      this.states.loading = true
      this.templates = []
      return Promise.all([
        api_admin.get_batch_fixed_template_ids(this.states.batchId),
        api_admin.get_testers_with_assigned_templates(this.states.batchId),
        api_admin.get_reports(this.states.batchId)
      ]).then(async ([ids, testers, r]) => {
        this.fixedTemplateIds = ids
        this.templates = Array.from(
          new Set(r.map(x => x.question.templateId))
        ).map(x => ({
          id: x,
          reports: r.filter(y => y.question.templateId == x)
        }))
        this.numTemplate = this.templates.length
        this.fixedTemplateIds = this.fixedTemplateIds.filter(
          x => this.templates.map(y => y.id).indexOf(x) != -1
        )
        if (this.states.doShowFixedTemplates == false) {
          this.templates = this.templates.filter(
            x => this.fixedTemplateIds.indexOf(x.id) == -1
          )
        }
        this.templates.sort((a, b) => a.id.localeCompare(b.id))
        var template_map = {}
        testers.map(t =>
          t.assignedTemplates.map(x => {
            if (!template_map[x.id]) {
              template_map[x.id] = []
            }
            template_map[x.id].push({ id: '' + t.id, name: '' + t.name })
          })
        )
        this.templates.map(x => {
          x.testers = template_map[x.id]
        })
        this.question = {}
        this.refQuestion = {}
        this.states.loading = false
      })
    },
    listChar (num) {
      return String.fromCharCode(65 + num)
    },
    onWindowsResize () {
      this.localEventHandler('window-resize')
    }
  }
}
</script>
<style scoped>
.line-break {
  word-wrap: break-word;
}
.clickable {
  cursor: pointer;
}
.report-panel {
  height: 400px;
  max-height: 60vh;
  overflow-y: auto;
}
.view-panel {
  max-height: 70vh;
  overflow-y: auto;
}
.refq {
  color: blue;
}
.refsol {
  color: blue;
}
.refans {
  color: blue;
}

.ans-lists {
  list-style-type: none;
  width: 100%;
}
.answer-style {
  padding: 10px 10px;
  margin: 5px 5px;
  font-size: 18px;
  border-radius: 23px;
  border: solid 1px #979797;
  display: inline-block;
}

.content-image {
  max-width: 250px;
  vertical-align: text-top;
  margin: 10px 10px;
}

.answer-image {
  max-width: 250px;
  vertical-align: text-top;
}
</style>
